import SearchResultsHeader from "@/components/SearchResultsHeader/SearchResultsHeader.vue";
import { adSubdomain, isSmallDevice } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    name: "LayoutStatic",
    components: {
        Advertising,
        SearchResultsHeader
    },
    data() {
        return {
            mobileNavIsOpen: false,
            subdomain: adSubdomain(this.$route.meta.subdomain)
        };
    },
    methods: {
        mobileMenuToggle(value) {
            this.mobileNavIsOpen = value;
        },
        isSmallDevice
    }
};



// WEBPACK FOOTER //
// ./src/layouts/LayoutStatic/LayoutStatic.js